(function () {
  'use strict';

  var SupportApp = {
    init: function () {
      if (!document.querySelector('.support')) return;

      this.initTOC();
      this.initHelpfulWidget();
      this.initDropdowns();
      this.initCheckboxLists();
      this.initTroubleshootingWidget();
      this.initForms();
      this.initScentToggle();
      this.initOrderLookup();
      this.initAccordion();
      this.initReturnRequest();
      this.initOrderIssueReport();
      this.initScentFitGuarantee();
      this.initReturnRequestAttachments();
      this.initFormFieldErrorClearing();
      this.initIssuePreselect();
      this.initSearch();
    },

    initTOC: function () {
      var toggles = document.querySelectorAll('[data-support-toc-toggle]');

      toggles.forEach(function (toggle) {
        var toc = toggle.closest('[data-support-toc]');
        var panel = toc && toc.querySelector('[data-support-toc-panel]');
        if (!panel) return;

        SupportApp.buildTOC(panel);

        if (!panel.children.length) {
          if (toc) toc.style.display = 'none';
          return;
        }

        toggle.addEventListener('click', function () {
          var expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          panel.classList.toggle('is-open', !expanded);
        });

        document.addEventListener('click', function (e) {
          if (!toggle.contains(e.target) && !panel.contains(e.target)) {
            toggle.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-open');
          }
        });

        panel.querySelectorAll('[data-support-toc-link]').forEach(function (link) {
          link.addEventListener('click', function (e) {
            e.preventDefault();
            var id = (link.getAttribute('href') || '').replace(/^#/, '');
            SupportApp.scrollToHeading(id);
            toggle.setAttribute('aria-expanded', 'false');
            panel.classList.remove('is-open');
          });
        });
      });
    },

    buildTOC: function (panel) {
      var sectionsRoot = document.querySelector('.support-article-body__sections');
      if (!sectionsRoot) return;

      panel.innerHTML = '';
      var seen = {};

      sectionsRoot.querySelectorAll('.support-article-body__section').forEach(function (section) {
        var sectionId = section.id;
        var heading = section.querySelector(':scope > .support__h3');

        if (sectionId && heading) {
          var label = heading.textContent.trim();
          if (label && !seen[sectionId]) {
            seen[sectionId] = true;
            panel.appendChild(SupportApp.createTOCLink(sectionId, label));
          }
        }

        section.querySelectorAll('.support-article-body__html h3.support__h3[id]').forEach(function (nestedHeading) {
          var nestedId = nestedHeading.id;
          var nestedLabel = nestedHeading.textContent.trim();
          if (nestedId && nestedLabel && !seen[nestedId]) {
            seen[nestedId] = true;
            panel.appendChild(SupportApp.createTOCLink(nestedId, nestedLabel));
          }
        });
      });
    },

    createTOCLink: function (id, label) {
      var link = document.createElement('a');
      link.href = '#' + id;
      link.className = 'support-toc__link';
      link.setAttribute('data-support-toc-link', '');
      link.textContent = label;
      return link;
    },

    scrollToHeading: function (id) {
      var target = document.getElementById(id);
      if (!target) return;

      var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    },

    initHelpfulWidget: function () {
      var widgets = document.querySelectorAll('[data-support-helpful]');
      var endpoint = '/apps/aura-backend/support/helpful-feedback';

      widgets.forEach(function (widget) {
        var form = widget.querySelector('[data-support-helpful-form]');
        var successMessage = widget.querySelector('[data-support-helpful-success]');
        var buttons = widget.querySelectorAll('[data-support-helpful-vote]');
        var handle = widget.getAttribute('data-article-handle');
        var pageUrl = widget.getAttribute('data-page-url') || window.location.href;
        var pageTitle = widget.getAttribute('data-page-title') || document.title;

        function showSuccess() {
          if (form) form.hidden = true;
          if (successMessage) successMessage.hidden = false;
          widget.classList.add('is-submitted');
        }

        buttons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (widget.classList.contains('is-submitted')) return;

            var helpful = btn.getAttribute('data-support-helpful-vote');
            buttons.forEach(function (b) {
              b.classList.remove('is-selected');
            });
            btn.classList.add('is-selected');

            fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({
                helpful: helpful,
                page_url: pageUrl,
                page_title: pageTitle,
                article_handle: handle,
              }),
            })
              .then(function (response) {
                return response.json().then(function (data) {
                  return { response: response, data: data };
                }).catch(function () {
                  return { response: response, data: {} };
                });
              })
              .then(function (result) {
                if (!result.response.ok || result.data.success === false) return;
                showSuccess();
              })
              .catch(function () {});
          });
        });
      });
    },

    initDropdowns: function (root) {
      var scope = root || document;
      var dropdowns = scope.querySelectorAll('[data-support-dropdown]');

      dropdowns.forEach(function (dropdown) {
        if (dropdown.hasAttribute('data-dropdown-bound')) return;
        dropdown.setAttribute('data-dropdown-bound', 'true');
        var select = dropdown.querySelector('select');
        var toggle = dropdown.querySelector('[data-support-dropdown-toggle]');
        var label = dropdown.querySelector('[data-support-dropdown-label]');
        var panel = dropdown.querySelector('[data-support-dropdown-panel]');
        if (!select || !toggle || !label || !panel) return;

        function getPlaceholder() {
          var placeholderOpt = select.querySelector('option[value=""][disabled]');
          return placeholderOpt ? placeholderOpt.textContent.trim() : 'Select';
        }

        function syncLabel() {
          var selected = select.options[select.selectedIndex];
          if (!selected || !selected.value) {
            label.textContent = getPlaceholder();
            label.classList.add('is-placeholder');
            return;
          }

          label.textContent = selected.textContent.trim();
          label.classList.remove('is-placeholder');
        }

        function syncOptions() {
          panel.innerHTML = '';

          Array.from(select.options).forEach(function (option) {
            if (option.disabled && !option.value) return;

            var item = document.createElement('button');
            item.type = 'button';
            item.className = 'support-dropdown__option';
            item.setAttribute('role', 'option');
            item.setAttribute('data-value', option.value);
            item.textContent = option.textContent.trim();

            if (option.selected && option.value) {
              item.setAttribute('aria-selected', 'true');
            }

            item.addEventListener('click', function () {
              // Setting .value can fail when the current option is disabled (placeholder).
              Array.from(select.options).forEach(function (opt) {
                opt.selected = opt === option;
              });
              select.dispatchEvent(new Event('change', { bubbles: true }));
              SupportApp.closeDropdown(dropdown);
              syncLabel();

              panel.querySelectorAll('.support-dropdown__option').forEach(function (entry) {
                entry.removeAttribute('aria-selected');
              });
              item.setAttribute('aria-selected', 'true');
            });

            panel.appendChild(item);
          });
        }

        toggle.addEventListener('click', function () {
          if (dropdown.classList.contains('is-open')) {
            SupportApp.closeDropdown(dropdown);
            return;
          }

          SupportApp.closeAllDropdowns();
          dropdown.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        });

        select.addEventListener('change', syncLabel);

        dropdown.supportDropdownSync = function () {
          syncOptions();
          syncLabel();
        };

        syncOptions();
        syncLabel();
      });

      if (!SupportApp._dropdownOutsideListener) {
        SupportApp._dropdownOutsideListener = true;
        document.addEventListener('click', function (event) {
          if (event.target.closest('[data-support-dropdown]')) return;
          SupportApp.closeAllDropdowns();
        });

        document.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            SupportApp.closeAllDropdowns();
          }
        });
      }
    },

    closeDropdown: function (dropdown) {
      if (!dropdown) return;

      dropdown.classList.remove('is-open');
      var toggle = dropdown.querySelector('[data-support-dropdown-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    },

    closeAllDropdowns: function () {
      document.querySelectorAll('[data-support-dropdown].is-open').forEach(function (dropdown) {
        SupportApp.closeDropdown(dropdown);
      });
    },

    initCheckboxLists: function () {
      var lists = document.querySelectorAll('[data-support-checkbox-list]');

      lists.forEach(function (list) {
        var rows = list.querySelectorAll('[data-support-checkbox-row]');
        var countEl = list.querySelector('[data-support-checkbox-count]');
        var selectAllBtn = list.querySelector('[data-support-select-all]');

        function updateCount() {
          var checked = list.querySelectorAll('[data-support-checkbox-row].is-checked').length;
          if (countEl) countEl.textContent = checked + ' selected';
        }

        rows.forEach(function (row) {
          var input = row.querySelector('input[type="checkbox"]');
          if (!input) return;

          input.addEventListener('change', function () {
            row.classList.toggle('is-checked', input.checked);
            updateCount();
          });
        });

        if (selectAllBtn) {
          selectAllBtn.addEventListener('click', function () {
            var allChecked = Array.from(rows).every(function (row) {
              var input = row.querySelector('input[type="checkbox"]');
              return input && input.checked;
            });

            rows.forEach(function (row) {
              var input = row.querySelector('input[type="checkbox"]');
              if (!input) return;
              input.checked = !allChecked;
              row.classList.toggle('is-checked', input.checked);
            });

            updateCount();
          });
        }

        updateCount();
      });
    },

    initTroubleshootingWidget: function () {
      var widgets = document.querySelectorAll('[data-support-troubleshoot]');

      widgets.forEach(function (widget) {
        var steps = widget.querySelectorAll('[data-support-step-checkbox], [data-support-section-checkbox]');
        var noBtn = widget.querySelector('[data-support-troubleshoot-no]');
        var yesBtn = widget.querySelector('[data-support-troubleshoot-yes]');
        var thanks = widget.querySelector('[data-support-troubleshoot-thanks]');
        var hint = widget.querySelector('[data-support-troubleshoot-hint]');
        var redirectUrl = widget.getAttribute('data-redirect-url') || '/pages/diffuser-troubleshooting-request';

        steps.forEach(function (cb) {
          cb.addEventListener('change', function () {
            var row = cb.closest('.support-troubleshoot-tried, .support-troubleshoot-step');
            if (row) row.classList.toggle('is-checked', cb.checked);
          });
        });

        if (yesBtn) {
          yesBtn.addEventListener('click', function () {
            if (thanks) thanks.classList.add('is-visible');
            var actions = widget.querySelector('[data-support-troubleshoot-actions]');
            if (actions) actions.style.display = 'none';
            if (hint) hint.style.display = 'none';
          });
        }

        if (noBtn) {
          noBtn.addEventListener('click', function () {
            var issue = widget.getAttribute('data-issue-handle') || '';
            window.location.href = redirectUrl + (issue ? '?issue=' + encodeURIComponent(issue) : '');
          });
        }
      });
    },

    initForms: function () {
      var forms = document.querySelectorAll('[data-support-form]');

      forms.forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();

          var endpoint = form.getAttribute('data-endpoint');
          var submitBtn = form.querySelector('[type="submit"]');
          var errorEl = form.querySelector('[data-support-form-error]');

          if (submitBtn) submitBtn.disabled = true;
          if (errorEl) errorEl.textContent = '';

          if (form.hasAttribute('data-support-return-request')) {
            SupportApp.submitReturnRequest(form)
              .then(function (result) {
                SupportApp.showFormSuccess(form, result);
              })
              .catch(function (err) {
                if (errorEl) errorEl.textContent = err.message;
                if (submitBtn) submitBtn.disabled = false;
              });
            return;
          }

          if (form.hasAttribute('data-support-diffuser-troubleshooting')) {
            SupportApp.submitDiffuserTroubleshootingRequest(form)
              .then(function (result) {
                SupportApp.showFormSuccess(form, result);
              })
              .catch(function (err) {
                if (errorEl) errorEl.textContent = err.message;
                if (submitBtn) submitBtn.disabled = false;
              });
            return;
          }

          if (form.hasAttribute('data-support-order-issue-report')) {
            SupportApp.submitOrderIssueReport(form)
              .then(function (result) {
                SupportApp.showFormSuccess(form, result);
              })
              .catch(function (err) {
                if (errorEl) errorEl.textContent = err.message;
                if (submitBtn) submitBtn.disabled = false;
              });
            return;
          }

          if (form.hasAttribute('data-support-scent-fit-guarantee')) {
            SupportApp.submitScentFitGuaranteeRequest(form)
              .then(function (result) {
                SupportApp.showFormSuccess(form, result);
              })
              .catch(function (err) {
                if (errorEl) errorEl.textContent = err.message;
                if (submitBtn) submitBtn.disabled = false;
              });
            return;
          }

          var formData = new FormData(form);
          var payload = SupportApp.formDataToPayload(formData);

          if (form.classList.contains('support-form--cancellation-request')) {
            var cancelError = SupportApp.validateCancellationRequestForm(form, formData);
            if (cancelError) {
              if (errorEl) errorEl.textContent = cancelError;
              if (submitBtn) submitBtn.disabled = false;
              return;
            }
          }

          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          })
            .then(function (res) {
              return SupportApp.parseJsonResponse(res).then(function (result) {
                var data = result.data;

                if (!res.ok || (data && data.success === false)) {
                  throw new Error(SupportApp.formatApiErrorMessage(data, res));
                }

                if (!data) {
                  throw new Error(SupportApp.formatApiErrorMessage(null, res));
                }

                return data;
              });
            })
            .then(function (data) {
              SupportApp.showFormSuccess(form, { data: data, payload: payload });
            })
            .catch(function (err) {
              if (errorEl) errorEl.textContent = err.message;
              if (submitBtn) submitBtn.disabled = false;
            });
        });
      });
    },

    formDataToPayload: function (formData) {
      var payload = {};

      formData.forEach(function (value, key) {
        if (key.endsWith('[]')) {
          var baseKey = key.slice(0, -2);
          if (!payload[baseKey]) payload[baseKey] = [];
          payload[baseKey].push(value);
        } else if (payload[key]) {
          if (!Array.isArray(payload[key])) payload[key] = [payload[key]];
          payload[key].push(value);
        } else {
          payload[key] = value;
        }
      });

      return payload;
    },

    validateCancellationRequestForm: function (form, formData) {
      var email = String(formData.get('email') || '').trim();
      var subscriptionType = String(formData.get('subscription_type') || '').trim();
      var cancelReason = String(formData.get('cancel_reason') || '').trim();

      if (!email) return 'Please enter your email address.';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Please enter a valid email address.';
      if (!subscriptionType) return 'Please select a subscription type.';
      if (!cancelReason) return 'Please select a reason for cancelling.';

      return null;
    },

    parseJsonResponse: function (res) {
      return res.text().then(function (text) {
        if (!text) {
          return { data: null };
        }

        try {
          return { data: JSON.parse(text) };
        } catch (err) {
          return { data: null, raw: text };
        }
      });
    },

    formatApiErrorMessage: function (data, res) {
      var parts = [];

      if (data && typeof data === 'object') {
        ['message', 'error', 'detail', 'description'].forEach(function (key) {
          var value = data[key];
          if (typeof value === 'string' && value.trim()) {
            parts.push(value.trim());
          }
        });

        if (data.errors && typeof data.errors === 'object') {
          Object.keys(data.errors).forEach(function (key) {
            var value = data.errors[key];

            if (Array.isArray(value)) {
              value.forEach(function (entry) {
                if (typeof entry === 'string' && entry.trim()) {
                  parts.push(entry.trim());
                }
              });
              return;
            }

            if (typeof value === 'string' && value.trim()) {
              parts.push(value.trim());
            }
          });
        }
      }

      if (parts.length) {
        var unique = [];
        parts.forEach(function (part) {
          if (unique.indexOf(part) === -1) {
            unique.push(part);
          }
        });
        return unique.join(' ');
      }

      if (res) {
        if (res.status === 404) {
          return 'We couldn\'t find an order matching that email and order number.';
        }
        if (res.status === 400 || res.status === 422) {
          return 'Please check the form and try again.';
        }
        if (res.status >= 500) {
          return 'Our server encountered an error. Please try again in a few minutes.';
        }
      }

      return 'Something went wrong. Please try again.';
    },

    buildReturnRequestPayload: function (form, formData) {
      var email = formData.get('email') || '';
      var orderNumber = String(formData.get('order_number') || '').replace(/^#/, '').trim();
      var selectedIds = formData.getAll('return_items[]');
      var items = selectedIds.map(function (id) {
        var card = form.querySelector('[data-support-return-item-card][data-item-id="' + id + '"]');
        var itemType = card ? card.getAttribute('data-item-type') : '';
        var details = formData.get('return_item_' + id + '_details');

        return {
          line_item_id: String(id),
          type: itemType,
          reason: formData.get('return_item_' + id + '_reason') || '',
          details: details || null,
          condition: formData.get('return_item_' + id + '_condition') || '',
          resolution: formData.get('return_item_' + id + '_resolution') || '',
        };
      });

      return {
        email: email,
        order_number: orderNumber,
        items: items,
      };
    },

    getAttachmentSizeLimit: function (file) {
      if (file.type.indexOf('video/') === 0) {
        return 500 * 1024 * 1024;
      }
      return 20 * 1024 * 1024;
    },

    getAttachmentSizeError: function (file) {
      if (file.type.indexOf('video/') === 0) {
        return 'Each video must be 500 MB or smaller.';
      }
      return 'Each image must be 20 MB or smaller.';
    },

    validateReturnRequestAttachments: function (files) {
      var MAX_FILES = 5;
      var ALLOWED_TYPES = new Set([
        'image/jpeg',
        'image/png',
        'image/webp',
        'image/gif',
        'video/mp4',
        'video/quicktime',
      ]);

      if (files.length > MAX_FILES) {
        return 'You can attach up to ' + MAX_FILES + ' files.';
      }

      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        if (file.size === 0) {
          return 'One or more selected files are empty. Re-select and try again.';
        }
        if (!ALLOWED_TYPES.has(file.type)) {
          return 'Please upload photos (JPEG, PNG, WebP, GIF) or videos (MP4, MOV) only.';
        }
        if (file.size > SupportApp.getAttachmentSizeLimit(file)) {
          return SupportApp.getAttachmentSizeError(file);
        }
      }

      return null;
    },

    clearFormFieldErrors: function (form) {
      if (!form) return;
      form.querySelectorAll('.is-invalid').forEach(function (el) {
        el.classList.remove('is-invalid');
      });
    },

    getFormFieldContainer: function (form, fieldName) {
      if (!form || !fieldName) return null;

      if (fieldName === 'attachment') {
        return form.querySelector('[data-support-attachment-picker]');
      }

      if (fieldName === 'return_items[]') {
        return form.querySelector('[data-support-return-items]');
      }

      if (fieldName === 'affected_items[]') {
        return form.querySelector('[data-support-order-issue-items]');
      }

      var control = form.querySelector('[name="' + fieldName + '"]');
      if (!control) return null;

      return control.closest('.support-field') || control.closest('[data-support-attachment-picker]');
    },

    markInvalidFields: function (form, fieldNames) {
      if (!form || !fieldNames || !fieldNames.length) return;

      SupportApp.clearFormFieldErrors(form);

      fieldNames.forEach(function (fieldName) {
        var container = SupportApp.getFormFieldContainer(form, fieldName);
        if (!container) return;

        container.classList.add('is-invalid');

        var card = container.closest('[data-support-return-item-card]');
        if (card) card.classList.add('is-invalid');
      });
    },

    scrollToFirstInvalidField: function (form) {
      if (!form) return;

      var invalid = form.querySelectorAll(
        '.support-field.is-invalid, [data-support-attachment-picker].is-invalid, .support-return-items.is-invalid, .support-order-issue-items.is-invalid, .support-return-item-card.is-invalid'
      );
      if (!invalid.length) return;

      var first = invalid[0];
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });

      var focusable = first.querySelector(
        'input:not([type="hidden"]):not([type="file"]):not([disabled]), textarea:not([disabled]), select:not([disabled]), [data-support-dropdown-toggle], [data-support-attachment-trigger]'
      );
      if (focusable && typeof focusable.focus === 'function') {
        focusable.focus({ preventScroll: true });
      }
    },

    showFormValidationErrors: function (form, validation) {
      if (!validation) return;

      SupportApp.markInvalidFields(form, validation.fields || []);
      SupportApp.scrollToFirstInvalidField(form);
    },

    initFormFieldErrorClearing: function () {
      var forms = document.querySelectorAll(
        '[data-support-diffuser-troubleshooting], [data-support-return-request], [data-support-order-issue-report]'
      );

      forms.forEach(function (form) {
        if (form.hasAttribute('data-field-error-clear-bound')) return;
        form.setAttribute('data-field-error-clear-bound', 'true');

        function clearFieldError(event) {
          var container = event.target.closest('.support-field, [data-support-attachment-picker], [data-support-return-items], [data-support-order-issue-items]');
          if (container) container.classList.remove('is-invalid');

          var card = event.target.closest('[data-support-return-item-card]');
          if (card && !card.querySelector('.support-field.is-invalid')) {
            card.classList.remove('is-invalid');
          }
        }

        form.addEventListener('input', clearFieldError);
        form.addEventListener('change', clearFieldError);
      });
    },

    validateReturnRequestForm: function (form, formData) {
      var errors = [];

      var email = String(formData.get('email') || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.push({ field: 'email', message: 'Please enter a valid email address.' });
      }

      var orderNumber = String(formData.get('order_number') || '').replace(/^#/, '').trim();
      if (!orderNumber) {
        errors.push({ field: 'order_number', message: 'Please enter your order number.' });
      }

      var selectedIds = formData.getAll('return_items[]');
      if (!selectedIds.length) {
        errors.push({ field: 'return_items[]', message: 'Please select at least one item to return.' });
      }

      for (var i = 0; i < selectedIds.length; i++) {
        var id = selectedIds[i];
        var reasonField = 'return_item_' + id + '_reason';
        var reason = formData.get(reasonField);
        if (!reason) {
          errors.push({
            field: reasonField,
            message: 'Please select a return reason for each item.',
          });
        }
        if (reason === 'other') {
          var detailsField = 'return_item_' + id + '_details';
          var details = String(formData.get(detailsField) || '').trim();
          if (!details) {
            errors.push({
              field: detailsField,
              message: 'Please provide details when selecting Other as the return reason.',
            });
          }
        }
      }

      if (!errors.length) return null;

      return {
        message: errors[0].message,
        fields: errors.map(function (error) {
          return error.field;
        }),
      };
    },

    submitReturnRequest: function (form) {
      var endpoint = form.getAttribute('data-submit-url') || form.getAttribute('data-endpoint');
      var formData = new FormData(form);
      SupportApp.clearFormFieldErrors(form);

      var formError = SupportApp.validateReturnRequestForm(form, formData);

      if (formError) {
        SupportApp.showFormValidationErrors(form, formError);
        return Promise.reject(new Error(formError.message));
      }

      var payload = SupportApp.buildReturnRequestPayload(form, formData);
      var fileInput = form.querySelector('[name="attachment"]');
      var files = fileInput && fileInput.files ? Array.from(fileInput.files) : [];
      var attachmentError = SupportApp.validateReturnRequestAttachments(files);

      if (attachmentError) {
        SupportApp.showFormValidationErrors(form, {
          message: attachmentError,
          fields: ['attachment'],
        });
        return Promise.reject(new Error(attachmentError));
      }

      var uploadFiles = files.filter(function (file) {
        return file.size > 0;
      });

      var fetchOptions;

      if (uploadFiles.length > 0) {
        var multipart = new FormData();
        multipart.append('payload', JSON.stringify(payload));
        uploadFiles.forEach(function (file) {
          multipart.append('attachment', file, file.name);
        });
        fetchOptions = { method: 'POST', body: multipart };
      } else {
        fetchOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        };
      }

      return fetch(endpoint, fetchOptions)
        .then(function (res) {
          return SupportApp.parseJsonResponse(res).then(function (result) {
            var data = result.data;

            if (!res.ok || (data && data.success === false)) {
              throw new Error(SupportApp.formatApiErrorMessage(data, res));
            }

            if (!data) {
              throw new Error(SupportApp.formatApiErrorMessage(null, res));
            }

            return { data: data, payload: payload };
          });
        })
        .catch(function (err) {
          if (err && err.message) {
            throw err;
          }
            throw new Error('Unable to connect. Please check your connection and try again.');
        });
    },

    buildDiffuserTroubleshootingPayload: function (form, formData) {
      var orderNumber = String(formData.get('order_number') || '').replace(/^#/, '').trim();
      var duration = String(formData.get('duration') || '').trim();

      return {
        email: String(formData.get('email') || '').trim(),
        order_number: orderNumber || null,
        issue_type: String(formData.get('issue_type') || '').trim(),
        description: String(formData.get('description') || '').trim(),
        diffuser_model: String(formData.get('diffuser_model') || '').trim(),
        duration: duration || null,
        steps_tried: formData.getAll('steps_tried[]'),
      };
    },

    validateDiffuserTroubleshootingForm: function (form, formData) {
      var errors = [];

      var email = String(formData.get('email') || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.push({ field: 'email', message: 'Please enter a valid email address.' });
      }

      if (!String(formData.get('issue_type') || '').trim()) {
        errors.push({ field: 'issue_type', message: 'Please select an issue type.' });
      }

      if (!String(formData.get('description') || '').trim()) {
        errors.push({ field: 'description', message: 'Please describe the issue in detail.' });
      }

      if (!String(formData.get('diffuser_model') || '').trim()) {
        errors.push({ field: 'diffuser_model', message: 'Please select a diffuser model.' });
      }

      if (!errors.length) return null;

      return {
        message: errors[0].message,
        fields: errors.map(function (error) {
          return error.field;
        }),
      };
    },

    submitDiffuserTroubleshootingRequest: function (form) {
      var endpoint = form.getAttribute('data-submit-url') || form.getAttribute('data-endpoint');
      var formData = new FormData(form);
      SupportApp.clearFormFieldErrors(form);

      var formError = SupportApp.validateDiffuserTroubleshootingForm(form, formData);

      if (formError) {
        SupportApp.showFormValidationErrors(form, formError);
        return Promise.reject(new Error(formError.message));
      }

      var payload = SupportApp.buildDiffuserTroubleshootingPayload(form, formData);
      var fileInput = form.querySelector('[name="attachment"]');
      var files = fileInput && fileInput.files ? Array.from(fileInput.files) : [];
      var attachmentError = SupportApp.validateReturnRequestAttachments(files);

      if (attachmentError) {
        SupportApp.showFormValidationErrors(form, {
          message: attachmentError,
          fields: ['attachment'],
        });
        return Promise.reject(new Error(attachmentError));
      }

      var uploadFiles = files.filter(function (file) {
        return file.size > 0;
      });

      var fetchOptions;

      if (uploadFiles.length > 0) {
        var multipart = new FormData();
        multipart.append('payload', JSON.stringify(payload));
        uploadFiles.forEach(function (file) {
          multipart.append('attachment', file, file.name);
        });
        fetchOptions = { method: 'POST', body: multipart };
      } else {
        fetchOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        };
      }

      return fetch(endpoint, fetchOptions)
        .then(function (res) {
          return SupportApp.parseJsonResponse(res).then(function (result) {
            var data = result.data;

            if (!res.ok || (data && data.success === false)) {
              throw new Error(SupportApp.formatApiErrorMessage(data, res));
            }

            if (!data) {
              throw new Error(SupportApp.formatApiErrorMessage(null, res));
            }

            return { data: data, payload: payload };
          });
        })
        .catch(function (err) {
          if (err && err.message) {
            throw err;
          }
          throw new Error('Unable to connect. Please check your connection and try again.');
        });
    },

    HIDDEN_PORTAL_PRODUCT_TYPE: 'fragrance oil upsell',

    normalizeProductType: function (productType) {
      return String(productType || '').toLowerCase().trim();
    },

    isHiddenPortalProductType: function (productType) {
      return SupportApp.normalizeProductType(productType) === SupportApp.HIDDEN_PORTAL_PRODUCT_TYPE;
    },

    isFragranceOilProductType: function (productType) {
      return SupportApp.normalizeProductType(productType) === 'fragrance oil';
    },

    classifyOrderIssueItemType: function (productType) {
      if (SupportApp.isHiddenPortalProductType(productType)) return null;
      var type = (productType || '').toLowerCase().trim();
      if (type === 'aura diffuser') return 'diffuser';
      if (type === 'fragrance oil') return 'oil';
      return null;
    },

    buildOrderIssueReportPayload: function (form, formData) {
      var orderNumber = String(formData.get('order_number') || '').replace(/^#/, '').trim();
      var lotCode = String(formData.get('lot_code') || '').trim();
      var notes = String(formData.get('notes') || '').trim();
      var selectedIds = formData.getAll('affected_items[]');

      var affectedItems = selectedIds.map(function (id) {
        var row = form.querySelector('[data-support-order-issue-items-rows] input[value="' + id + '"]');
        var title = '';
        if (row) {
          var label = row.closest('[data-support-checkbox-row]');
          var labelEl = label ? label.querySelector('.support-checkbox-list__label') : null;
          title = labelEl ? labelEl.textContent.trim() : '';
        }

        return {
          line_item_id: String(id),
          title: title,
          type: row ? row.getAttribute('data-item-type') || null : null,
        };
      });

      return {
        email: String(formData.get('email') || '').trim(),
        order_number: orderNumber,
        affected_items: affectedItems,
        issue_type: String(formData.get('issue_type') || '').trim(),
        description: String(formData.get('description') || '').trim(),
        lot_code: lotCode || null,
        notes: notes || null,
      };
    },

    validateOrderIssueReportForm: function (form, formData) {
      var errors = [];

      var email = String(formData.get('email') || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.push({ field: 'email', message: 'Please enter a valid email address.' });
      }

      var orderNumber = String(formData.get('order_number') || '').replace(/^#/, '').trim();
      if (!orderNumber) {
        errors.push({ field: 'order_number', message: 'Please enter your order number.' });
      }

      var selectedIds = formData.getAll('affected_items[]');
      if (!selectedIds.length) {
        errors.push({
          field: 'affected_items[]',
          message: 'Please select at least one affected item.',
        });
      }

      if (!String(formData.get('issue_type') || '').trim()) {
        errors.push({ field: 'issue_type', message: 'Please select an issue type.' });
      }

      if (!String(formData.get('description') || '').trim()) {
        errors.push({ field: 'description', message: 'Please describe the issue in detail.' });
      }

      if (!errors.length) return null;

      return {
        message: errors[0].message,
        fields: errors.map(function (error) {
          return error.field;
        }),
      };
    },

    submitOrderIssueReport: function (form) {
      var endpoint = form.getAttribute('data-submit-url') || form.getAttribute('data-endpoint');
      var formData = new FormData(form);
      SupportApp.clearFormFieldErrors(form);

      var formError = SupportApp.validateOrderIssueReportForm(form, formData);

      if (formError) {
        SupportApp.showFormValidationErrors(form, formError);
        return Promise.reject(new Error(formError.message));
      }

      var payload = SupportApp.buildOrderIssueReportPayload(form, formData);
      var fileInput = form.querySelector('[name="attachment"]');
      var files = fileInput && fileInput.files ? Array.from(fileInput.files) : [];
      var attachmentError = SupportApp.validateReturnRequestAttachments(files);

      if (attachmentError) {
        SupportApp.showFormValidationErrors(form, {
          message: attachmentError,
          fields: ['attachment'],
        });
        return Promise.reject(new Error(attachmentError));
      }

      var uploadFiles = files.filter(function (file) {
        return file.size > 0;
      });

      var fetchOptions;

      if (uploadFiles.length > 0) {
        var multipart = new FormData();
        multipart.append('payload', JSON.stringify(payload));
        uploadFiles.forEach(function (file) {
          multipart.append('attachment', file, file.name);
        });
        fetchOptions = { method: 'POST', body: multipart };
      } else {
        fetchOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        };
      }

      return fetch(endpoint, fetchOptions)
        .then(function (res) {
          return SupportApp.parseJsonResponse(res).then(function (result) {
            var data = result.data;

            if (!res.ok || (data && data.success === false)) {
              throw new Error(SupportApp.formatApiErrorMessage(data, res));
            }

            if (!data) {
              throw new Error(SupportApp.formatApiErrorMessage(null, res));
            }

            return { data: data, payload: payload };
          });
        })
        .catch(function (err) {
          if (err && err.message) {
            throw err;
          }
          throw new Error('Unable to connect. Please check your connection and try again.');
        });
    },

    showFormSuccess: function (form, result) {
      var pageRoot =
        form.closest('.support-return-request-page') ||
        form.closest('.support-diffuser-troubleshooting-page') ||
        form.closest('.support-order-issue-report-page') ||
        form.closest('.support-scent-fit-guarantee-page') ||
        form.closest('.support-cancellation-request-page') ||
        form.closest('.support');
      var main = pageRoot && pageRoot.querySelector('[data-support-form-main]');
      var successSection = pageRoot && pageRoot.querySelector('[data-support-form-success-section]');
      var success = pageRoot && pageRoot.querySelector('[data-support-success]');
      var requestId = null;

      if (result && typeof result === 'object') {
        if (result.data) {
          requestId = result.data.request_id || result.data.reference || null;
        } else {
          requestId = result.request_id || result.reference || null;
        }
      }

      if (!success) {
        var wrapper = form.closest('[data-support-form-wrapper]');
        success = wrapper && wrapper.querySelector('[data-support-success]');
      }

      if (main) {
        main.hidden = true;
        main.setAttribute('aria-hidden', 'true');
      } else {
        form.classList.add('is-hidden');
      }

      if (successSection) {
        successSection.hidden = false;
        successSection.setAttribute('aria-hidden', 'false');
      }

      if (success) {
        var referenceEl = success.querySelector('[data-support-success-reference]');
        var referenceValueEl = success.querySelector('[data-support-success-reference-value]');

        if (referenceEl && referenceValueEl) {
          if (requestId) {
            referenceValueEl.textContent = requestId;
            referenceEl.hidden = false;
          } else {
            referenceValueEl.textContent = '';
            referenceEl.hidden = true;
          }
        }

        success.classList.add('is-visible');
        requestAnimationFrame(function () {
          success.style.opacity = '1';
          if (pageRoot) {
            pageRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      }
    },

    initScentToggle: function () {
      var toggles = document.querySelectorAll('[data-support-scent-toggle]');

      toggles.forEach(function (toggle) {
        var yesBtn = toggle.querySelector('[data-scent-toggle="yes"]');
        var noBtn = toggle.querySelector('[data-scent-toggle="no"]');
        var choiceBlock = toggle.closest('[data-support-scent-fit-choice]');
        var replacementField = choiceBlock
          ? choiceBlock.querySelector('[data-support-scent-replacement]')
          : document.querySelector('[data-support-scent-replacement]');
        var moodField = choiceBlock
          ? choiceBlock.querySelector('[data-support-scent-mood]')
          : document.querySelector('[data-support-scent-mood]');
        var hiddenInput =
          toggle.parentElement.querySelector('[name="replacement_preference"]') ||
          toggle.parentElement.querySelector('[name="knows_replacement"]');

        function setActive(knows) {
          if (yesBtn) yesBtn.classList.toggle('is-active', knows);
          if (noBtn) noBtn.classList.toggle('is-active', !knows);

          if (replacementField) {
            replacementField.hidden = !knows;
          }

          if (moodField) {
            moodField.hidden = knows;
          }

          if (hiddenInput) {
            if (hiddenInput.name === 'replacement_preference') {
              hiddenInput.value = knows ? 'known' : 'help_choose';
            } else {
              hiddenInput.value = knows ? 'yes' : 'no';
            }
          }
        }

        if (yesBtn) yesBtn.addEventListener('click', function () { setActive(true); });
        if (noBtn) noBtn.addEventListener('click', function () { setActive(false); });

        setActive(yesBtn && yesBtn.classList.contains('is-active'));
      });
    },

    initOrderLookup: function () {
      var lookups = document.querySelectorAll('[data-support-order-lookup]');

      lookups.forEach(function (lookup) {
        var btn = lookup.querySelector('[data-support-lookup-btn]');
        var productsEl = lookup.querySelector('[data-support-order-products]');
        var errorEl = lookup.querySelector('[data-support-lookup-error]');
        var form = lookup.closest('form');

        if (!btn) return;

        btn.addEventListener('click', function () {
          var emailInput = lookup.querySelector('[name="email"]');
          var orderInput = lookup.querySelector('[name="order_number"]');
          var email = emailInput ? emailInput.value : '';
          var orderNumber = orderInput ? orderInput.value : '';

          if (errorEl) errorEl.textContent = '';
          btn.disabled = true;

          fetch('/apps/aura-backend/support/lookup-order', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: email, order_number: orderNumber }),
          })
            .then(function (res) {
              return res.json().then(function (data) {
                if (!res.ok || !data.success) {
                  throw new Error(data.message || 'Order not found');
                }
                return data;
              });
            })
            .then(function (data) {
              if (!productsEl) return;
              productsEl.innerHTML = '';

              (data.order.line_items || []).forEach(function (item) {
                var el = document.createElement('label');
                el.className = 'support-order-product';
                el.innerHTML =
                  '<input type="radio" name="selected_product" value="' +
                  item.id +
                  '" style="display:none">' +
                  (item.image_url
                    ? '<img class="support-order-product__image" src="' +
                      item.image_url +
                      '" alt="">'
                    : '') +
                  '<span class="support-order-product__title">' +
                  item.title +
                  '</span>';

                el.addEventListener('click', function () {
                  productsEl.querySelectorAll('.support-order-product').forEach(function (p) {
                    p.classList.remove('is-selected');
                  });
                  el.classList.add('is-selected');
                  var radio = el.querySelector('input[type="radio"]');
                  if (radio) radio.checked = true;
                });

                productsEl.appendChild(el);
              });

              productsEl.classList.add('is-visible');
              lookup.setAttribute('data-lookup-complete', 'true');
            })
            .catch(function (err) {
              if (errorEl) errorEl.textContent = err.message;
            })
            .finally(function () {
              btn.disabled = false;
            });
        });
      });
    },

    initAccordion: function () {
      var accordions = document.querySelectorAll('[data-support-accordion]');

      accordions.forEach(function (accordion) {
        var triggers = accordion.querySelectorAll('[data-support-accordion-trigger]');

        triggers.forEach(function (trigger) {
          trigger.addEventListener('click', function () {
            var expanded = trigger.getAttribute('aria-expanded') === 'true';
            var panel = trigger.parentElement.querySelector('[data-support-accordion-panel]');

            triggers.forEach(function (t) {
              t.setAttribute('aria-expanded', 'false');
              var p = t.parentElement.querySelector('[data-support-accordion-panel]');
              if (p) p.classList.remove('is-open');
            });

            if (!expanded) {
              trigger.setAttribute('aria-expanded', 'true');
              if (panel) panel.classList.add('is-open');
            }
          });
        });
      });
    },

    initReturnRequest: function () {
      var form = document.querySelector('[data-support-return-request]');
      if (!form) return;

      var ordersData = { orders: [] };
      var ordersJsonEl = document.getElementById('support-return-orders-json');
      if (ordersJsonEl) {
        try {
          ordersData = JSON.parse(ordersJsonEl.textContent);
        } catch (err) {
          ordersData = { orders: [] };
        }
      }

      var itemsList = form.querySelector('[data-support-return-items-list]');
      var itemsRows = form.querySelector('[data-support-return-items-rows]');
      var itemsMessage = form.querySelector('[data-support-return-items-message]');
      var cardsContainer = form.querySelector('[data-support-return-item-cards]');
      var orderInput = form.querySelector('[name="order_number"]');
      var emailInput = form.querySelector('[name="email"]');
      var isLoggedIn = form.hasAttribute('data-customer-logged-in');

      var DIFFUSER_REASONS = [
        { value: 'changed-mind', label: 'Changed my mind' },
        { value: 'defective', label: 'Defective / not working' },
        { value: 'wrong-item', label: 'Wrong item received' },
        { value: 'other', label: 'Other (please specify)' },
      ];

      var OIL_REASONS = [
        { value: 'scent-not-expected', label: 'Scent not as expected' },
        { value: 'allergic-reaction', label: 'Allergic reaction' },
        { value: 'wrong-item', label: 'Wrong item received' },
        { value: 'other', label: 'Other (please specify)' },
      ];

      function classifyProductType(productType, title) {
        if (SupportApp.isHiddenPortalProductType(productType)) return null;
        var type = (productType || '').toLowerCase().trim();
        if (type === 'aura diffuser') return 'diffuser';
        if (type === 'fragrance oil') return 'oil';
        return null;
      }

      function normalizeLineItems(items) {
        return (items || [])
          .map(function (item) {
            var itemType = item.type || classifyProductType(item.product_type, item.title);
            if (itemType !== 'diffuser' && itemType !== 'oil') return null;
            return {
              id: item.id,
              title: item.title,
              type: itemType,
            };
          })
          .filter(Boolean);
      }

      function getOrderNumber() {
        if (!orderInput) return '';
        return orderInput.value.replace(/^#/, '').trim();
      }

      function getLineItemsForOrder(orderNumber) {
        var order = (ordersData.orders || []).find(function (entry) {
          return String(entry.number) === String(orderNumber);
        });
        return order ? order.line_items || [] : [];
      }

      function buildReasonOptions(itemType) {
        var reasons = itemType === 'diffuser' ? DIFFUSER_REASONS : OIL_REASONS;
        return reasons
          .map(function (reason) {
            return '<option value="' + reason.value + '">' + reason.label + '</option>';
          })
          .join('');
      }

      function buildDropdownMarkup(id, name, itemType) {
        var options = buildReasonOptions(itemType);
        return (
          '<div class="support-dropdown" data-support-dropdown>' +
          '<select id="' + id + '" name="' + name + '" class="support-dropdown__select" tabindex="-1" aria-hidden="true"' +
          ' data-support-return-reason-select="">' +
          '<option value="" disabled selected>Select a reason</option>' +
          options +
          '</select>' +
          '<button type="button" class="support-dropdown__toggle" data-support-dropdown-toggle aria-expanded="false" aria-haspopup="listbox" aria-controls="' +
          id +
          '-panel" id="' +
          id +
          '-toggle">' +
          '<span class="support-dropdown__label is-placeholder" data-support-dropdown-label></span>' +
          '<svg class="support-dropdown__chevron" viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
          '<path d="M2 4L6 8L10 4" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
          '</svg></button>' +
          '<div class="support-dropdown__panel" id="' +
          id +
          '-panel" data-support-dropdown-panel role="listbox" aria-labelledby="' +
          id +
          '-toggle"></div></div>'
        );
      }

      function buildSegmentToggle(name, leftLabel, leftValue, rightLabel, rightValue, defaultValue) {
        var leftActive = defaultValue === leftValue ? ' is-active' : '';
        var rightActive = defaultValue === rightValue ? ' is-active' : '';
        return (
          '<div class="support-segment-toggle" data-support-segment-toggle>' +
          '<button type="button" class="support-segment-toggle__btn' +
          leftActive +
          '" data-segment-value="' +
          leftValue +
          '">' +
          leftLabel +
          '</button>' +
          '<button type="button" class="support-segment-toggle__btn' +
          rightActive +
          '" data-segment-value="' +
          rightValue +
          '">' +
          rightLabel +
          '</button>' +
          '<input type="hidden" name="' +
          name +
          '" value="' +
          defaultValue +
          '">' +
          '</div>'
        );
      }

      function buildReturnItemCard(item) {
        var itemId = String(item.id);
        var badge = item.type === 'diffuser' ? 'DIFFUSER' : 'SCENT';
        var reasonFieldId = 'return_reason_' + itemId;
        var card = document.createElement('div');
        card.className = 'support-return-item-card';
        card.setAttribute('data-support-return-item-card', '');
        card.setAttribute('data-item-id', itemId);
        card.setAttribute('data-item-type', item.type);
        card.hidden = true;

        card.innerHTML =
          '<div class="support-return-item-card__header">' +
          '<span class="support-return-item-card__title">' +
          item.title +
          '</span>' +
          '<span class="support-return-item-card__badge">' +
          badge +
          '</span>' +
          '</div>' +
          '<div class="support-return-item-card__body">' +
          '<div class="support-field">' +
          '<label class="support-field__label" for="' +
          reasonFieldId +
          '">Reason for return *</label>' +
          buildDropdownMarkup(reasonFieldId, 'return_item_' + itemId + '_reason', item.type) +
          '</div>' +
          '<div class="support-field support-return-item-card__other" data-support-return-other hidden>' +
          '<textarea id="return_details_' +
          itemId +
          '" name="return_item_' +
          itemId +
          '_details" class="support-field__textarea" placeholder="Tell us a bit more…"></textarea>' +
          '<p class="support-field__hint">A sentence or two is perfect.</p>' +
          '</div>' +
          '<div class="support-field">' +
          '<label class="support-field__label">Has it been opened or used?</label>' +
          buildSegmentToggle('return_item_' + itemId + '_condition', 'Unopened', 'unopened', 'Opened / used', 'opened', 'unopened') +
          '</div>' +
          '<div class="support-field">' +
          '<label class="support-field__label">Refund or exchange?</label>' +
          buildSegmentToggle('return_item_' + itemId + '_resolution', 'Refund', 'refund', 'Exchange', 'exchange', 'refund') +
          '</div>' +
          '</div>';

        card.querySelectorAll('select, textarea, input[type="hidden"]').forEach(function (field) {
          field.disabled = true;
        });

        return card;
      }

      function bindSegmentToggles(root) {
        var toggles = (root || document).querySelectorAll('[data-support-segment-toggle]');
        toggles.forEach(function (toggle) {
          if (toggle.hasAttribute('data-segment-bound')) return;
          toggle.setAttribute('data-segment-bound', 'true');

          var hiddenInput = toggle.querySelector('input[type="hidden"]');
          var buttons = toggle.querySelectorAll('[data-segment-value]');

          buttons.forEach(function (button) {
            button.addEventListener('click', function () {
              var value = button.getAttribute('data-segment-value');
              buttons.forEach(function (btn) {
                btn.classList.toggle('is-active', btn === button);
              });
              if (hiddenInput) hiddenInput.value = value;
            });
          });
        });
      }

      function bindReasonSelect(card) {
        var select = card.querySelector('[data-support-return-reason-select]');
        var otherField = card.querySelector('[data-support-return-other]');
        var otherTextarea = otherField ? otherField.querySelector('textarea') : null;

        if (!select) return;

        function syncOtherField() {
          var isOther = select.value === 'other';
          if (otherField) otherField.hidden = !isOther;
          if (otherTextarea) {
            otherTextarea.required = false;
            if (!isOther) otherTextarea.value = '';
          }
        }

        select.addEventListener('change', syncOtherField);
        syncOtherField();
      }

      function setCardVisible(itemId, visible) {
        var card = cardsContainer.querySelector('[data-item-id="' + itemId + '"]');
        if (!card) return;

        card.hidden = !visible;
        card.querySelectorAll('input, select, textarea, button').forEach(function (field) {
          if (field.matches('[data-support-dropdown-toggle], [data-segment-value], [data-support-select-all]')) return;
          field.disabled = !visible;
        });

        if (visible) {
          bindReasonSelect(card);
          bindSegmentToggles(card);
          SupportApp.initDropdowns(card);
        }
      }

      function bindReturnCheckboxList() {
        if (!itemsList || !itemsRows) return;

        var rows = itemsRows.querySelectorAll('[data-support-checkbox-row]');
        var countEl = itemsList.querySelector('[data-support-checkbox-count]');
        var selectAllBtn = itemsList.querySelector('[data-support-select-all]');

        function updateCount() {
          var checked = itemsRows.querySelectorAll('[data-support-checkbox-row].is-checked').length;
          if (countEl) countEl.textContent = checked + ' selected';
        }

        rows.forEach(function (row) {
          var input = row.querySelector('input[type="checkbox"]');
          if (!input) return;

          input.addEventListener('change', function () {
            row.classList.toggle('is-checked', input.checked);
            setCardVisible(input.value, input.checked);
            updateCount();
          });
        });

        if (selectAllBtn && !itemsList.hasAttribute('data-return-select-all-bound')) {
          itemsList.setAttribute('data-return-select-all-bound', 'true');
          selectAllBtn.addEventListener('click', function () {
            var currentRows = itemsRows.querySelectorAll('[data-support-checkbox-row]');
            var allChecked = Array.from(currentRows).every(function (row) {
              var input = row.querySelector('input[type="checkbox"]');
              return input && input.checked;
            });

            currentRows.forEach(function (row) {
              var input = row.querySelector('input[type="checkbox"]');
              if (!input) return;
              input.checked = !allChecked;
              row.classList.toggle('is-checked', input.checked);
              setCardVisible(input.value, input.checked);
            });

            var countElCurrent = itemsList.querySelector('[data-support-checkbox-count]');
            if (countElCurrent) {
              var checkedCount = itemsRows.querySelectorAll('[data-support-checkbox-row].is-checked').length;
              countElCurrent.textContent = checkedCount + ' selected';
            }
          });
        }

        updateCount();
      }

      function renderLineItems(lineItems) {
        if (!itemsList || !itemsRows || !cardsContainer) return;

        itemsRows.innerHTML = '';
        cardsContainer.innerHTML = '';

        var returnableItems = (lineItems || []).filter(function (item) {
          return item.type === 'diffuser' || item.type === 'oil';
        });

        if (returnableItems.length === 0) {
          itemsList.hidden = true;
          if (itemsMessage) {
            itemsMessage.hidden = false;
            itemsMessage.textContent = isLoggedIn
              ? 'No returnable items found on this order.'
              : 'Enter your email and order number to see returnable items.';
          }
          return;
        }

        if (itemsMessage) itemsMessage.hidden = true;
        itemsList.hidden = false;

        returnableItems.forEach(function (item) {
          var row = document.createElement('label');
          row.className = 'support-checkbox-list__row';
          row.setAttribute('data-support-checkbox-row', '');
          row.innerHTML =
            '<input type="checkbox" class="support-checkbox-list__input" name="return_items[]" value="' +
            item.id +
            '" data-item-type="' +
            item.type +
            '">' +
            '<span class="support-checkbox-list__box">' +
            '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6L5 9L10 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</span>' +
            '<span class="support-checkbox-list__label">' +
            item.title +
            '</span>';

          itemsRows.appendChild(row);
          cardsContainer.appendChild(buildReturnItemCard(item));
        });

        bindReturnCheckboxList();
      }

      function fetchOrderLineItems(orderNumber) {
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) {
          renderLineItems([]);
          if (itemsMessage) {
            itemsMessage.hidden = false;
            itemsMessage.textContent = isLoggedIn
              ? 'No returnable items found on this order.'
              : 'Enter your email and order number to see returnable items.';
          }
          return;
        }

        fetch('/apps/aura-backend/support/lookup-order', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            order_number: orderNumber,
          }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok || !data.success) {
                throw new Error(data.message || 'Order not found');
              }
              return data;
            });
          })
          .then(function (data) {
            var items = normalizeLineItems(data.order.line_items || []);
            renderLineItems(items);
            if (items.length === 0 && itemsMessage) {
              itemsMessage.hidden = false;
              itemsMessage.textContent = 'No returnable diffuser or fragrance oil items found on this order.';
            }
          })
          .catch(function () {
            renderLineItems([]);
            if (itemsMessage) {
              itemsMessage.hidden = false;
              itemsMessage.textContent = 'We could not find returnable items for that order.';
            }
          });
      }

      function loadItemsForCurrentOrder() {
        var orderNumber = getOrderNumber();
        if (!orderNumber) {
          renderLineItems([]);
          return;
        }

        var embeddedItems = normalizeLineItems(getLineItemsForOrder(orderNumber));
        if (embeddedItems.length > 0) {
          renderLineItems(embeddedItems);
          return;
        }

        fetchOrderLineItems(orderNumber);
      }

      if (orderInput) {
        orderInput.addEventListener('change', loadItemsForCurrentOrder);
        if (orderInput.tagName === 'INPUT') {
          orderInput.addEventListener('blur', loadItemsForCurrentOrder);
        }
      }

      if (emailInput && !isLoggedIn) {
        emailInput.addEventListener('change', loadItemsForCurrentOrder);
        emailInput.addEventListener('blur', loadItemsForCurrentOrder);
      }

      requestAnimationFrame(function () {
        loadItemsForCurrentOrder();
      });
    },

    initOrderIssueReport: function () {
      var form = document.querySelector('[data-support-order-issue-report]');
      if (!form) return;

      var ordersData = { orders: [] };
      var ordersJsonEl = document.getElementById('support-order-issue-orders-json');
      if (ordersJsonEl) {
        try {
          ordersData = JSON.parse(ordersJsonEl.textContent);
        } catch (err) {
          ordersData = { orders: [] };
        }
      }

      var itemsList = form.querySelector('[data-support-order-issue-items-list]');
      var itemsRows = form.querySelector('[data-support-order-issue-items-rows]');
      var itemsMessage = form.querySelector('[data-support-order-issue-items-message]');
      var orderInput = form.querySelector('[name="order_number"]');
      var emailInput = form.querySelector('[name="email"]');
      var isLoggedIn = form.hasAttribute('data-customer-logged-in');

      function normalizeLineItems(items) {
        return (items || [])
          .filter(function (item) {
            return !SupportApp.isHiddenPortalProductType(item.product_type);
          })
          .map(function (item) {
            return {
              id: item.id,
              title: item.title,
              type: SupportApp.classifyOrderIssueItemType(item.product_type),
            };
          });
      }

      function getOrderNumber() {
        if (!orderInput) return '';
        return orderInput.value.replace(/^#/, '').trim();
      }

      function getLineItemsForOrder(orderNumber) {
        var order = (ordersData.orders || []).find(function (entry) {
          return String(entry.number) === String(orderNumber);
        });
        return order ? order.line_items || [] : [];
      }

      function bindOrderIssueCheckboxList() {
        if (!itemsList || !itemsRows) return;

        var rows = itemsRows.querySelectorAll('[data-support-checkbox-row]');
        var countEl = itemsList.querySelector('[data-support-checkbox-count]');
        var selectAllBtn = itemsList.querySelector('[data-support-select-all]');

        function updateCount() {
          var checked = itemsRows.querySelectorAll('[data-support-checkbox-row].is-checked').length;
          if (countEl) countEl.textContent = checked + ' selected';
        }

        rows.forEach(function (row) {
          var input = row.querySelector('input[type="checkbox"]');
          if (!input) return;

          input.addEventListener('change', function () {
            row.classList.toggle('is-checked', input.checked);
            updateCount();
          });
        });

        if (selectAllBtn && !itemsList.hasAttribute('data-order-issue-select-all-bound')) {
          itemsList.setAttribute('data-order-issue-select-all-bound', 'true');
          selectAllBtn.addEventListener('click', function () {
            var currentRows = itemsRows.querySelectorAll('[data-support-checkbox-row]');
            var allChecked = Array.from(currentRows).every(function (row) {
              var input = row.querySelector('input[type="checkbox"]');
              return input && input.checked;
            });

            currentRows.forEach(function (row) {
              var input = row.querySelector('input[type="checkbox"]');
              if (!input) return;
              input.checked = !allChecked;
              row.classList.toggle('is-checked', input.checked);
            });

            updateCount();
          });
        }

        updateCount();
      }

      function renderLineItems(lineItems) {
        if (!itemsList || !itemsRows) return;

        itemsRows.innerHTML = '';

        var orderItems = lineItems || [];

        if (orderItems.length === 0) {
          itemsList.hidden = true;
          if (itemsMessage) {
            itemsMessage.hidden = false;
            itemsMessage.textContent = isLoggedIn
              ? 'No items found on this order.'
              : 'Enter your email and order number to see items from your order.';
          }
          return;
        }

        if (itemsMessage) itemsMessage.hidden = true;
        itemsList.hidden = false;

        orderItems.forEach(function (item) {
          var row = document.createElement('label');
          row.className = 'support-checkbox-list__row';
          row.setAttribute('data-support-checkbox-row', '');
          row.innerHTML =
            '<input type="checkbox" class="support-checkbox-list__input" name="affected_items[]" value="' +
            item.id +
            '"' +
            (item.type ? ' data-item-type="' + item.type + '"' : '') +
            '>' +
            '<span class="support-checkbox-list__box">' +
            '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6L5 9L10 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</span>' +
            '<span class="support-checkbox-list__label">' +
            item.title +
            '</span>';

          itemsRows.appendChild(row);
        });

        bindOrderIssueCheckboxList();
      }

      function fetchOrderLineItems(orderNumber) {
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) {
          renderLineItems([]);
          if (itemsMessage) {
            itemsMessage.hidden = false;
            itemsMessage.textContent = isLoggedIn
              ? 'No items found on this order.'
              : 'Enter your email and order number to see items from your order.';
          }
          return;
        }

        fetch('/apps/aura-backend/support/lookup-order', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            order_number: orderNumber,
          }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok || !data.success) {
                throw new Error(data.message || 'Order not found');
              }
              return data;
            });
          })
          .then(function (data) {
            var items = normalizeLineItems(data.order.line_items || []);
            renderLineItems(items);
            if (items.length === 0 && itemsMessage) {
              itemsMessage.hidden = false;
              itemsMessage.textContent = 'No items found on this order.';
            }
          })
          .catch(function () {
            renderLineItems([]);
            if (itemsMessage) {
              itemsMessage.hidden = false;
              itemsMessage.textContent = 'We could not find items for that order.';
            }
          });
      }

      function loadItemsForCurrentOrder() {
        var orderNumber = getOrderNumber();
        if (!orderNumber) {
          renderLineItems([]);
          return;
        }

        var embeddedItems = normalizeLineItems(getLineItemsForOrder(orderNumber));
        if (embeddedItems.length > 0) {
          renderLineItems(embeddedItems);
          return;
        }

        fetchOrderLineItems(orderNumber);
      }

      if (orderInput) {
        orderInput.addEventListener('change', loadItemsForCurrentOrder);
        if (orderInput.tagName === 'INPUT') {
          orderInput.addEventListener('blur', loadItemsForCurrentOrder);
        }
      }

      if (emailInput && !isLoggedIn) {
        emailInput.addEventListener('change', loadItemsForCurrentOrder);
        emailInput.addEventListener('blur', loadItemsForCurrentOrder);
      }

      requestAnimationFrame(function () {
        loadItemsForCurrentOrder();
      });
    },

    classifyScentFitItem: function (item) {
      if (!item) return null;

      var handle = String(item.product_handle || item.handle || '')
        .toLowerCase()
        .trim();
      var title = String(item.title || '').toLowerCase().trim();
      var oilCatalog = SupportApp._scentFitOilCatalog || [];
      var oilHandles = SupportApp._scentFitOilHandles || [];

      var productType = (item.product_type || '').toLowerCase().trim();
      if (SupportApp.isHiddenPortalProductType(productType)) return null;
      if (
        productType === 'aura diffuser' ||
        productType === 'diffuser cleaner' ||
        productType === 'gift card'
      ) {
        return null;
      }

      if (title.indexOf('diffuser cleaner') !== -1) return null;

      function buildOilItem(matchedHandle) {
        return {
          id: item.id,
          title: item.title,
          type: 'oil',
          product_type: item.product_type || null,
          product_handle: matchedHandle || handle || null,
        };
      }

      if (handle && oilHandles.indexOf(handle) !== -1) {
        return buildOilItem(handle);
      }

      var catalogMatch = oilCatalog.find(function (oil) {
        var oilHandle = String(oil.handle || '').toLowerCase().trim();
        var oilTitle = String(oil.title || '').toLowerCase().trim();
        return (handle && oilHandle === handle) || (title && oilTitle === title);
      });

      if (catalogMatch) {
        return buildOilItem(String(catalogMatch.handle || '').toLowerCase().trim());
      }

      var type = (item.type || '').toLowerCase().trim();
      if (type === 'oil') {
        return buildOilItem(handle || null);
      }

      if (SupportApp.isFragranceOilProductType(productType)) {
        return buildOilItem(handle || null);
      }

      return null;
    },

    rebuildScentFitDropdown: function (select, items, placeholder) {
      if (!select) return;

      var dropdown = select.closest('[data-support-dropdown]');
      var currentValue = select.value;
      select.innerHTML = '';

      var placeholderOption = document.createElement('option');
      placeholderOption.value = '';
      placeholderOption.disabled = true;
      placeholderOption.selected = true;
      placeholderOption.textContent = placeholder || 'Select a scent';
      select.appendChild(placeholderOption);

      items.forEach(function (item) {
        var option = document.createElement('option');
        option.value = String(item.id);
        option.textContent = item.title;
        option.setAttribute('data-product-handle', item.product_handle || '');
        select.appendChild(option);
      });

      if (currentValue && select.querySelector('option[value="' + currentValue + '"]')) {
        select.value = currentValue;
        placeholderOption.selected = false;
      }

      if (dropdown) {
        if (typeof dropdown.supportDropdownSync === 'function') {
          dropdown.supportDropdownSync();
        } else {
          dropdown.removeAttribute('data-dropdown-bound');
          SupportApp.initDropdowns(document);
        }
      }
    },

    buildScentFitGuaranteePayload: function (form, formData) {
      var orderNumber = String(formData.get('order_number') || '').replace(/^#/, '').trim();
      var currentScentId = String(formData.get('current_scent') || '').trim();
      var currentScentSelect = form.querySelector('[name="current_scent"]');
      var currentOption =
        currentScentSelect && currentScentSelect.options[currentScentSelect.selectedIndex];
      var replacementPreference = String(formData.get('replacement_preference') || 'help_choose').trim();
      var replacementScent = String(formData.get('replacement_scent') || '').trim();
      var notes = String(formData.get('notes') || '').trim();
      var moodPreferences = [];

      form.querySelectorAll('[data-support-mood-chips] .support-mood-chip.is-selected').forEach(function (chip) {
        var value = chip.getAttribute('data-mood-value');
        if (value) moodPreferences.push(value);
      });

      return {
        email: String(formData.get('email') || '').trim(),
        order_number: orderNumber || null,
        current_scent: {
          line_item_id: currentScentId,
          title: currentOption ? currentOption.textContent.trim() : '',
          product_handle: currentOption ? currentOption.getAttribute('data-product-handle') || null : null,
        },
        swap_reason: String(formData.get('swap_reason') || '').trim(),
        replacement_preference: replacementPreference,
        replacement_scent: replacementPreference === 'known' ? replacementScent || null : null,
        mood_preferences: replacementPreference === 'help_choose' ? moodPreferences : [],
        notes: notes || null,
      };
    },

    validateScentFitGuaranteeForm: function (form, formData) {
      var errors = [];
      var email = String(formData.get('email') || '').trim();

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errors.push({ field: 'email', message: 'Please enter a valid email address.' });
      }

      if (!String(formData.get('current_scent') || '').trim()) {
        errors.push({ field: 'current_scent', message: 'Please select the scent you are swapping out.' });
      }

      if (!String(formData.get('swap_reason') || '').trim()) {
        errors.push({ field: 'swap_reason', message: 'Please select a reason for swapping.' });
      }

      var replacementPreference = String(formData.get('replacement_preference') || 'help_choose').trim();

      if (replacementPreference === 'known' && !String(formData.get('replacement_scent') || '').trim()) {
        errors.push({
          field: 'replacement_scent',
          message: 'Please select the replacement scent you would like.',
        });
      }

      if (replacementPreference === 'help_choose') {
        var selectedMoods = form.querySelectorAll('[data-support-mood-chips] .support-mood-chip.is-selected').length;
        if (!selectedMoods) {
          errors.push({
            field: 'mood_preferences',
            message: 'Please pick at least one mood preference.',
          });
        }
      }

      if (!errors.length) return null;

      return {
        message: errors[0].message,
        fields: errors.map(function (error) {
          return error.field;
        }),
      };
    },

    submitScentFitGuaranteeRequest: function (form) {
      var endpoint = form.getAttribute('data-submit-url') || form.getAttribute('data-endpoint');
      var formData = new FormData(form);
      SupportApp.clearFormFieldErrors(form);

      var formError = SupportApp.validateScentFitGuaranteeForm(form, formData);

      if (formError) {
        SupportApp.showFormValidationErrors(form, formError);
        return Promise.reject(new Error(formError.message));
      }

      var payload = SupportApp.buildScentFitGuaranteePayload(form, formData);

      return fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then(function (res) {
          return SupportApp.parseJsonResponse(res).then(function (result) {
            var data = result.data;

            if (!res.ok || (data && data.success === false)) {
              throw new Error(SupportApp.formatApiErrorMessage(data, res));
            }

            if (!data) {
              throw new Error(SupportApp.formatApiErrorMessage(null, res));
            }

            return { data: data, payload: payload };
          });
        })
        .catch(function (err) {
          if (err && err.message) {
            throw err;
          }
          throw new Error('Unable to connect. Please check your connection and try again.');
        });
    },

    initScentFitGuarantee: function () {
      var form = document.querySelector('[data-support-scent-fit-guarantee]');
      if (!form) return;

      SupportApp._scentFitOilCatalog = [];
      SupportApp._scentFitOilHandles = [];
      var oilCatalogEl = document.getElementById('support-scent-fit-oil-catalog-json');
      if (oilCatalogEl) {
        try {
          SupportApp._scentFitOilCatalog = JSON.parse(oilCatalogEl.textContent).map(function (oil) {
            return {
              handle: String(oil.handle || '').toLowerCase().trim(),
              title: String(oil.title || '').toLowerCase().trim(),
            };
          });
          SupportApp._scentFitOilHandles = SupportApp._scentFitOilCatalog.map(function (oil) {
            return oil.handle;
          });
        } catch (err) {
          SupportApp._scentFitOilCatalog = [];
          SupportApp._scentFitOilHandles = [];
        }
      }

      var ordersData = { orders: [] };
      var ordersJsonEl = document.getElementById('support-scent-fit-orders-json');
      if (ordersJsonEl) {
        try {
          ordersData = JSON.parse(ordersJsonEl.textContent);
        } catch (err) {
          ordersData = { orders: [] };
        }
      }

      var currentScentSelect = form.querySelector('[name="current_scent"]');
      var itemsMessage = form.querySelector('[data-support-scent-fit-items-message]');
      var orderInput = form.querySelector('[name="order_number"]');
      var emailInput = form.querySelector('[name="email"]');
      var isLoggedIn = form.hasAttribute('data-customer-logged-in');
      var moodChips = form.querySelectorAll('[data-support-mood-chips] .support-mood-chip');

      function getOrderNumber() {
        if (!orderInput) return '';
        return orderInput.value.replace(/^#/, '').trim();
      }

      function getLineItemsForOrder(orderNumber) {
        var order = (ordersData.orders || []).find(function (entry) {
          return String(entry.number) === String(orderNumber);
        });
        return order ? order.line_items || [] : [];
      }

      function normalizeOrderFragranceOils(items) {
        return (items || [])
          .map(function (item) {
            return SupportApp.classifyScentFitItem(item);
          })
          .filter(Boolean);
      }

      function renderOrderFragranceOils(items) {
        var fragranceOils = normalizeOrderFragranceOils(items);

        if (!fragranceOils.length) {
          SupportApp.rebuildScentFitDropdown(currentScentSelect, [], 'Select a scent');
          if (itemsMessage) {
            itemsMessage.hidden = false;
            itemsMessage.textContent = isLoggedIn
              ? 'No fragrance oils found on this order.'
              : 'Enter your email and order number to see fragrance oils from your order.';
          }
          return;
        }

        if (itemsMessage) itemsMessage.hidden = true;
        SupportApp.rebuildScentFitDropdown(currentScentSelect, fragranceOils, 'Select a scent');

        if (fragranceOils.length === 1 && currentScentSelect) {
          currentScentSelect.value = String(fragranceOils[0].id);
          currentScentSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      function fetchOrderFragranceOils(orderNumber, keepEmbeddedOnError) {
        var email = emailInput ? emailInput.value.trim() : '';
        if (!email) {
          if (!keepEmbeddedOnError) {
            renderOrderFragranceOils([]);
          }
          return;
        }

        fetch('/apps/aura-backend/support/lookup-order', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            order_number: orderNumber,
          }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok || !data.success) {
                throw new Error(data.message || 'Order not found');
              }
              return data;
            });
          })
          .then(function (data) {
            var apiItems = data.order.line_items || [];
            var apiOils = normalizeOrderFragranceOils(apiItems);

            if (apiOils.length > 0 || !keepEmbeddedOnError) {
              renderOrderFragranceOils(apiItems);
            }
          })
          .catch(function () {
            if (keepEmbeddedOnError) return;

            renderOrderFragranceOils([]);
            if (itemsMessage) {
              itemsMessage.hidden = false;
              itemsMessage.textContent = 'We could not find fragrance oils for that order.';
            }
          });
      }

      function loadScentsForCurrentOrder() {
        var orderNumber = getOrderNumber();
        if (!orderNumber) {
          renderOrderFragranceOils([]);
          return;
        }

        var embeddedLineItems = getLineItemsForOrder(orderNumber);
        var embeddedOils = normalizeOrderFragranceOils(embeddedLineItems);
        var hasEmbeddedOils = embeddedOils.length > 0;

        if (hasEmbeddedOils) {
          renderOrderFragranceOils(embeddedLineItems);
        }

        fetchOrderFragranceOils(orderNumber, hasEmbeddedOils);
      }

      moodChips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var isSelected = chip.classList.toggle('is-selected');
          chip.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });
      });

      if (orderInput) {
        orderInput.addEventListener('change', loadScentsForCurrentOrder);
        orderInput.addEventListener('input', loadScentsForCurrentOrder);
        if (orderInput.tagName === 'INPUT') {
          orderInput.addEventListener('blur', loadScentsForCurrentOrder);
        }
      }

      if (emailInput) {
        emailInput.addEventListener('change', loadScentsForCurrentOrder);
        emailInput.addEventListener('blur', loadScentsForCurrentOrder);
      }

      requestAnimationFrame(function () {
        loadScentsForCurrentOrder();
      });
    },

    initReturnRequestAttachments: function () {
      var pickers = document.querySelectorAll('[data-support-attachment-picker]');

      pickers.forEach(function (picker) {
        if (picker.hasAttribute('data-attachment-bound')) return;
        picker.setAttribute('data-attachment-bound', 'true');

        var input = picker.querySelector('[data-support-attachment-input]');
        var empty = picker.querySelector('[data-support-attachment-empty]');
        var grid = picker.querySelector('[data-support-attachment-grid]');
        var form = picker.closest('form');
        var files = [];
        var previewUrls = [];
        var MAX_FILES = 5;

        if (!input || !empty || !grid) return;

        function getFormErrorEl() {
          return form ? form.querySelector('[data-support-form-error]') : null;
        }

        function validateSingleFile(file) {
          var allowed = [
            'image/jpeg',
            'image/png',
            'image/webp',
            'image/gif',
            'video/mp4',
            'video/quicktime',
          ];

          if (file.size === 0) {
            return 'One or more selected files are empty. Re-select and try again.';
          }
          if (allowed.indexOf(file.type) === -1) {
            return 'Please upload photos (JPEG, PNG, WebP, GIF) or videos (MP4, MOV) only.';
          }
          if (file.size > SupportApp.getAttachmentSizeLimit(file)) {
            return SupportApp.getAttachmentSizeError(file);
          }
          return null;
        }

        function revokePreviews() {
          previewUrls.forEach(function (url) {
            URL.revokeObjectURL(url);
          });
          previewUrls = [];
        }

        function syncInput() {
          var dt = new DataTransfer();
          files.forEach(function (file) {
            dt.items.add(file);
          });
          input.files = dt.files;
        }

        function openFilePicker() {
          input.click();
        }

        function render() {
          revokePreviews();
          grid.innerHTML = '';

          if (files.length === 0) {
            empty.hidden = false;
            grid.hidden = true;
            return;
          }

          empty.hidden = true;
          grid.hidden = false;

          files.forEach(function (file, index) {
            var tile = document.createElement('div');
            tile.className = 'support-attachment-picker__tile';

            if (file.type.indexOf('video/') === 0) {
              var videoPlaceholder = document.createElement('div');
              videoPlaceholder.className = 'support-attachment-picker__video';
              videoPlaceholder.innerHTML =
                '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                '<path d="M8 5v14l11-7L8 5z" fill="currentColor"/>' +
                '</svg>' +
                '<span>Video</span>';
              tile.appendChild(videoPlaceholder);
            } else {
              var url = URL.createObjectURL(file);
              previewUrls.push(url);
              var img = document.createElement('img');
              img.className = 'support-attachment-picker__thumb';
              img.src = url;
              img.alt = file.name;
              tile.appendChild(img);
            }

            var removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'support-attachment-picker__remove';
            removeBtn.setAttribute('aria-label', 'Remove ' + file.name);
            removeBtn.innerHTML =
              '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true">' +
              '<path d="M3 3l6 6M9 3L3 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/>' +
              '</svg>';
            removeBtn.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              files.splice(index, 1);
              syncInput();
              render();
            });
            tile.appendChild(removeBtn);
            grid.appendChild(tile);
          });

          if (files.length < MAX_FILES) {
            var addBtn = document.createElement('button');
            addBtn.type = 'button';
            addBtn.className = 'support-attachment-picker__add';
            addBtn.setAttribute('aria-label', 'Add more files');
            addBtn.innerHTML =
              '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
              '<path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>' +
              '</svg>';
            addBtn.addEventListener('click', function (e) {
              e.preventDefault();
              openFilePicker();
            });
            grid.appendChild(addBtn);
          }
        }

        picker.querySelectorAll('[data-support-attachment-trigger]').forEach(function (trigger) {
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            openFilePicker();
          });
        });

        input.addEventListener('change', function () {
          var incoming = Array.from(input.files || []);
          var errorEl = getFormErrorEl();
          if (errorEl) errorEl.textContent = '';

          incoming.forEach(function (file) {
            if (files.length >= MAX_FILES) {
              if (errorEl) errorEl.textContent = 'You can attach up to ' + MAX_FILES + ' files.';
              return;
            }

            var fileError = validateSingleFile(file);
            if (fileError) {
              if (errorEl) errorEl.textContent = fileError;
              return;
            }

            files.push(file);
          });

          syncInput();
          render();
        });

        render();
      });
    },

    initSearch: function () {
      var SEARCH_ENDPOINT = '/apps/aura-backend/search/support';
      var DEBOUNCE_MS = 300;
      var MIN_QUERY_LENGTH = 1;

      document.querySelectorAll('[data-support-search]').forEach(function (wrap) {
        if (wrap.hasAttribute('data-search-bound')) return;
        wrap.setAttribute('data-search-bound', 'true');

        var input = wrap.querySelector('[data-support-search-input]');
        var combobox = wrap.querySelector('[role="combobox"]');
        var panel = wrap.querySelector('[data-support-search-panel]');
        var label = wrap.querySelector('[data-support-search-label]');
        var status = wrap.querySelector('[data-support-search-status]');
        var results = wrap.querySelector('[data-support-search-results]');
        if (!input || !panel || !results) return;

        if (!results.id) {
          results.id = 'support-search-results-' + Math.random().toString(36).slice(2, 9);
        }
        input.setAttribute('aria-controls', results.id);
        if (combobox) combobox.setAttribute('aria-owns', results.id);

        var popular = [];
        try {
          popular = JSON.parse(wrap.getAttribute('data-support-search-popular') || '[]');
        } catch (e) {
          popular = [];
        }

        var debounceTimer = null;
        var activeController = null;
        var activeQuery = '';

        function setExpanded(isOpen) {
          wrap.classList.toggle('is-open', isOpen);
          if (combobox) combobox.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          panel.hidden = !isOpen;
        }

        function closePanel() {
          setExpanded(false);
          results.innerHTML = '';
          if (label) label.hidden = true;
          if (status) {
            status.hidden = true;
            status.textContent = '';
          }
        }

        function createResultLink(item) {
          var li = document.createElement('li');
          li.className = 'support-search__result-item';
          li.setAttribute('role', 'none');

          var link = document.createElement('a');
          link.className = 'support-search__result';
          link.href = item.url || '#';
          link.setAttribute('role', 'option');

          var title = document.createElement('span');
          title.className = 'support-search__result-title';
          title.textContent = item.title || '';

          link.appendChild(title);
          link.insertAdjacentHTML(
            'beforeend',
            '<svg class="support-search__result-chevron" viewBox="0 0 8 14" fill="none" aria-hidden="true"><path d="M1 1L7 7L1 13" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          );

          li.appendChild(link);
          return li;
        }

        function renderItems(items, headerText, statusText) {
          results.innerHTML = '';

          if (label) {
            label.textContent = headerText || '';
            label.hidden = !headerText;
          }

          if (status) {
            status.textContent = statusText || '';
            status.hidden = !statusText;
          }

          if (!items.length) {
            setExpanded(true);
            return;
          }

          items.forEach(function (item) {
            if (!item.url) return;
            results.appendChild(createResultLink(item));
          });

          setExpanded(true);
        }

        function showPopular() {
          activeQuery = '';
          if (activeController) {
            activeController.abort();
            activeController = null;
          }

          renderItems(popular, 'POPULAR ARTICLES', '');
        }

        function showLoading(query) {
          if (label) label.hidden = true;
          if (status) {
            status.textContent = 'Searching…';
            status.hidden = false;
          }
          results.innerHTML = '';
          setExpanded(true);
          activeQuery = query;
        }

        function search(query) {
          if (activeController) activeController.abort();

          var controller = new AbortController();
          activeController = controller;

          var params = new URLSearchParams({ q: query, limit: '10' });

          fetch(SEARCH_ENDPOINT + '?' + params.toString(), { signal: controller.signal })
            .then(function (response) {
              if (!response.ok) throw new Error('Search failed');
              return response.json();
            })
            .then(function (data) {
              if (activeQuery !== query) return;

              var items = (data && data.results) || [];
              if (!items.length) {
                renderItems([], '', 'No results found. Try a different search.');
                return;
              }

              renderItems(items, '', '');
            })
            .catch(function (error) {
              if (error && error.name === 'AbortError') return;
              if (activeQuery !== query) return;
              renderItems([], '', 'Search is temporarily unavailable. Please try again.');
            })
            .finally(function () {
              if (activeController === controller) activeController = null;
            });
        }

        function handleInput() {
          clearTimeout(debounceTimer);

          var query = input.value.trim();
          if (!query) {
            showPopular();
            return;
          }

          if (query.length < MIN_QUERY_LENGTH) {
            closePanel();
            return;
          }

          debounceTimer = setTimeout(function () {
            showLoading(query);
            search(query);
          }, DEBOUNCE_MS);
        }

        input.addEventListener('focus', function () {
          if (!input.value.trim()) showPopular();
        });

        input.addEventListener('input', handleInput);

        input.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            closePanel();
            input.blur();
          }
        });

        wrap.addEventListener('click', function (event) {
          event.stopPropagation();
        });

        if (!SupportApp._searchOutsideListener) {
          SupportApp._searchOutsideListener = true;

          document.addEventListener('click', function () {
            document.querySelectorAll('[data-support-search].is-open').forEach(function (openWrap) {
              var openPanel = openWrap.querySelector('[data-support-search-panel]');
              var openCombobox = openWrap.querySelector('[role="combobox"]');
              var openLabel = openWrap.querySelector('[data-support-search-label]');
              var openStatus = openWrap.querySelector('[data-support-search-status]');
              var openResults = openWrap.querySelector('[data-support-search-results]');
              openWrap.classList.remove('is-open');
              if (openCombobox) openCombobox.setAttribute('aria-expanded', 'false');
              if (openPanel) openPanel.hidden = true;
              if (openLabel) openLabel.hidden = true;
              if (openStatus) {
                openStatus.hidden = true;
                openStatus.textContent = '';
              }
              if (openResults) openResults.innerHTML = '';
            });
          });

          document.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape') return;
            document.querySelectorAll('[data-support-search].is-open').forEach(function (openWrap) {
              var openInput = openWrap.querySelector('[data-support-search-input]');
              var openPanel = openWrap.querySelector('[data-support-search-panel]');
              var openCombobox = openWrap.querySelector('[role="combobox"]');
              var openLabel = openWrap.querySelector('[data-support-search-label]');
              var openStatus = openWrap.querySelector('[data-support-search-status]');
              var openResults = openWrap.querySelector('[data-support-search-results]');
              openWrap.classList.remove('is-open');
              if (openCombobox) openCombobox.setAttribute('aria-expanded', 'false');
              if (openPanel) openPanel.hidden = true;
              if (openLabel) openLabel.hidden = true;
              if (openStatus) {
                openStatus.hidden = true;
                openStatus.textContent = '';
              }
              if (openResults) openResults.innerHTML = '';
              if (openInput) openInput.blur();
            });
          });
        }
      });
    },

    initIssuePreselect: function () {
      var params = new URLSearchParams(window.location.search);
      var issue = params.get('issue');
      if (!issue) return;

      var select = document.querySelector('[data-support-issue-select]');
      if (!select) return;

      var mapping = {
        'my-diffuser-isnt-misting': 'not-misting',
        'the-scent-is-too-strong': 'scent-too-strong',
        'not-turning-on': 'not-turning-on',
        'not-working-after-a-few-weeks': 'not-working-weeks',
      };

      var value = mapping[issue] || issue;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      SupportApp.init();
    });
  } else {
    SupportApp.init();
  }

  window.SupportApp = SupportApp;
})();
